export function getTranslation(state) {
  return state.brand.settings.translation;
}

export function getBrand(state) {
  return state.brand.settings;
}



// WEBPACK FOOTER //
// ./src/modules/brand/brand-selectors.js